import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "count", "form", "actionInput", "row"]

  connect() {
    this.updateUI()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  toggleOne() {
    this.updateUI()
  }

  updateUI() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length

    // Update count display
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }

    // Show/hide action bar
    if (this.hasActionBarTarget) {
      if (count > 0) {
        this.actionBarTarget.classList.remove("hidden")
        this.actionBarTarget.classList.add("flex")
      } else {
        this.actionBarTarget.classList.add("hidden")
        this.actionBarTarget.classList.remove("flex")
      }
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length
      if (count === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (count === total) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }

    // Highlight selected rows
    this.rowTargets.forEach((row, index) => {
      if (this.checkboxTargets[index] && this.checkboxTargets[index].checked) {
        row.classList.add("bg-[#C4A484]/5")
      } else {
        row.classList.remove("bg-[#C4A484]/5")
      }
    })
  }

  submitAction(event) {
    const action = event.currentTarget.dataset.bulkAction
    const count = this.checkboxTargets.filter(cb => cb.checked).length

    // updateUI hides the whole action bar at zero, so this is a guard, not
    // a message: there is no button to click here. It used to raise the
    // browser's alert(), which the native-modal house rule bans.
    if (count === 0) return

    let confirmMessage
    switch (action) {
      case "delete":
        confirmMessage = `Are you sure you want to delete ${count} user(s)? This cannot be undone.`
        break
      case "activate":
        confirmMessage = `Activate ${count} user(s)?`
        break
      case "deactivate":
        confirmMessage = `Deactivate ${count} user(s)?`
        break
      default:
        confirmMessage = `Perform action on ${count} user(s)?`
    }

    // The app modal, never the browser's confirm() (owner directive
    // 2026-08-13). On /admin there is no #turbo-confirm-dialog element, so
    // appConfirm builds its own styled modal; this is the same door the
    // per-row buttons take through Turbo.setConfirmMethod.
    window.appConfirm(confirmMessage, { confirmLabel: "Confirm", focus: "cancel" }).then(ok => {
      if (!ok) return
      this.actionInputTarget.value = action
      this.formTarget.requestSubmit()
    })
  }

  clearSelection() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.updateUI()
  }
}
